<div *ngIf="showRA">
    <nav-header></nav-header>
    <router-outlet></router-outlet>
    <fluency-modal></fluency-modal>
    <selection-modal></selection-modal>
    <message-modal></message-modal>
    <debug-log-modal></debug-log-modal>
    <please-wait></please-wait>
    <pipeline-save-modal></pipeline-save-modal>
    <pipeline-modal></pipeline-modal>
    <pipeline-batch-modal></pipeline-batch-modal>
    <pipeline-pronunciations-modal></pipeline-pronunciations-modal>
    <question-report-modal></question-report-modal>
</div>

